import React, { useCallback, useState, useContext } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { ReduxRouterAction } from 'redux-router/lib/actionCreators';
import { redirectus } from 'ggApp/modules/router/actions';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';

import { OutItemType, currentObjType } from 'ggApp/modules/SwapCheckout/swap.d';

import { SwapModal } from './styles';
import Step from './components/Step';

interface SwapModalProps {
    modalRef: (ref: any) => void;
    send: (arg1: string, arg2?: object) => {};
    current: currentObjType;
    modal: any;
    redirect: (url: string, external: boolean) => void | Dispatch<ReduxRouterAction>;
    swapedItems: {
        newItem: object;
        oldItems: object[];
    };
}

export const SwapCheckoutComponent = ({
    redirect,
    modalRef,
    current,
    send,
    modal,
    swapedItems,
}: SwapModalProps) => {
    const { activeStore, user } = useContext(OrderContext);
    const [outDevice, setOutDevice] = useState<OutItemType | null>(null);

    const inDevice = {
        variant: {
            id: current?.context?.newItem?.id,
            imageUrl: current?.context?.newItem?.image,
            coreAttribute: current?.context?.newItem?.coreAttribute,
        },
        product: {
            id: current?.context?.newItem?.id,
            name: current?.context?.newItem?.name,
        },
    };

    const onOpen = useCallback(() => {
        send('NEXT');
        send('SET_USER', { data: user });
        send('UPDATE_SWAP_ITEMS', swapedItems);
    }, [send, user, swapedItems]);

    const redirectToYourTech = useCallback(
        () => redirect(`/${activeStore?.code}/your-tech`, true),
        [redirect, activeStore],
    );

    const closeModal = useCallback(() => {
        if (current.matches('confirmation')) {
            redirectToYourTech();
        }

        if (modal) {
            modal.closeModal();
        }
        setOutDevice(null);
    }, [current, modal, setOutDevice, redirectToYourTech]);

    return (
        <SwapModal
            className="swapCheckoutModal"
            modalRef={modalRef}
            onOpen={onOpen}
            onClose={() => send('CLOSE')}
            shouldCloseOnClick={false}
        >
            <Step
                current={current}
                outDevice={outDevice}
                setOutDevice={setOutDevice}
                send={send}
                inDevice={inDevice}
                redirectToYourTech={redirectToYourTech}
                closeModal={closeModal}
            />
        </SwapModal>
    );
};

export const SwapCheckout = connect<any, any, any>(
    null,
    (dispatch: Dispatch<ReduxRouterAction>) => ({
        redirect: bindActionCreators(redirectus, dispatch),
    }),
)(SwapCheckoutComponent);
